import React, { useState } from 'react';
import CountUp from 'react-countup';
import { useInView } from 'react-intersection-observer';

const Counter = ({ end }) => {
  const [hasAnimated, setHasAnimated] = useState(false);
  const { ref, inView } = useInView({
    triggerOnce: true, 
    threshold: 0.5, 
  });

  if (inView && !hasAnimated) {
    setHasAnimated(true);
  }

  return (
    <div ref={ref} className="flex justify-center items-center">
      <div className="text-center">
        <h2 className="text-4xl font-bold text-gray-800">
          {hasAnimated ? <CountUp end={end} duration={3} /> : '0'}
        </h2>
      </div>
    </div>
  );
};

export default Counter;



